import { AddTask } from "@mui/icons-material";
import { Box, Button, Tooltip } from "@mui/material";
import { memo } from "react";
import { useMessageInputHandlers } from "../../../App/State/Hooks/MessageDialog/useMessageInput";
import {
  useMessageScheduleHandlers,
  useMessageScheduleState,
} from "../../../App/State/Hooks/MessageDialog/useMessageSchedule";
import { MessageCalendarOptions } from "../../SendGroupMessage/Components/MessageCalendarOptions/MessageCalendarOptions";
import { MessageActionButton } from "../../SendGroupMessage/Components/SharedComponents/MessageActionButton";
import PendingMessageQueue from "../../SendGroupMessage/Components/SharedComponents/PendingMessageQueue";

export default function ScheduleEmail({
  InputEmailComponent,
  showScheduleButton = false,
  disableScheduleButton = false,
  disableAddButton = false,
  handleSendScheduledMessage = () => {
    return;
  },
  tooltipText,
  tooltipTextButton,
  sendCount,
  isGroup,
}: {
  InputEmailComponent: JSX.Element;
  showScheduleButton?: boolean;
  disableScheduleButton?: boolean;
  disableAddButton?: boolean;
  handleSendScheduledMessage?: () => void;
  tooltipText?: string;
  tooltipTextButton?: string;
  sendCount: number;
  isGroup: boolean;
}) {
  const { handleClearInputState } = useMessageInputHandlers();
  const messageScheduleState = useMessageScheduleState();
  const { handleAddMessageToListQueue } = useMessageScheduleHandlers();

  const handleAddButtonClick = () => {
    handleAddMessageToListQueue();
    handleClearInputState();
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <MessageCalendarOptions />
      </Box>
      {InputEmailComponent}

      <Box sx={{ display: "flex", mt: 1 }}>
        <Tooltip title={tooltipTextButton || ""} arrow>
          <Box>
            <Button
              id="add-message-to-list-button"
              aria-haspopup="true"
              variant="contained"
              disableElevation
              onClick={handleAddButtonClick}
              endIcon={<AddTask />}
              disabled={disableAddButton}
            >
              Add Message To List
            </Button>
          </Box>
        </Tooltip>
      </Box>
      <PendingMessageQueue />
      {showScheduleButton && (
        <Box sx={{ mt: 2, display: "flex" }}>
          <MessageActionButton
            buttonText="Schedule Messages"
            disableButton={disableScheduleButton || !messageScheduleState.msgListQueue.length}
            tooltipText={tooltipText || ""}
            disabledTooltipText="Cannot schedule messages"
            data-test="schedule-message-button"
            isGroup={isGroup}
            onClick={handleSendScheduledMessage}
            sendCount={sendCount}
          />
        </Box>
      )}
    </Box>
  );
}

export const MemoScheduleEmail = memo(ScheduleEmail);
